export default __webpack_public_path__ + "static/logo-bree-e5303947133e082115d950ec2c7d0a2e.svg";